import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialStatsState } from 'store/initial-states';
import {
  getCompleteActivityLogQuestionsAnswers,
  getCompletedLogsByActivityInTimeRange,
  getHabitsConsistencyStats,
  getStatsByActivityPerDay
} from './extra';

const statsSlice = createSlice({
  name: 'stats',
  initialState: initialStatsState,
  reducers: {
    resetStatsSummaries: (state) => {
      state.summaries = [];
    },
    updateSelectedHabitId: (state, { payload }: PayloadAction<string>) => {
      state.selectedHabitId = payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getCompletedLogsByActivityInTimeRange.pending, (state) => {
        state.isRoutineStatsLoading = true;
        state.isHeatmapLoading = true;
      })
      .addCase(
        getCompletedLogsByActivityInTimeRange.fulfilled,
        (state, { payload }) => {
          state.isRoutineStatsLoading = false;
          state.isHeatmapLoading = false;
          state.summaries = payload ?? [];
        }
      )
      .addCase(getCompletedLogsByActivityInTimeRange.rejected, (state) => {
        state.isRoutineStatsLoading = false;
        state.isHeatmapLoading = false;
        state.summaries = [];
        state.logQuestionSummaries = [];
      })
      .addCase(getCompleteActivityLogQuestionsAnswers.pending, (state) => {
        state.isRoutineStatsLoading = true;
      })
      .addCase(
        getCompleteActivityLogQuestionsAnswers.fulfilled,
        (state, { payload }) => {
          state.isRoutineStatsLoading = false;
          state.logQuestionSummaries = payload ?? [];
        }
      )
      .addCase(getCompleteActivityLogQuestionsAnswers.rejected, (state) => {
        state.isRoutineStatsLoading = false;
      })
      .addCase(getStatsByActivityPerDay.pending, (state) => {
        state.isRoutineStatsLoading = true;
      })
      .addCase(getStatsByActivityPerDay.fulfilled, (state) => {
        state.isRoutineStatsLoading = false;
      })
      .addCase(getStatsByActivityPerDay.rejected, (state) => {
        state.isRoutineStatsLoading = false;
      })
      .addCase(getHabitsConsistencyStats.pending, (state) => {
        state.isConsistencyStatsLoading = true;
        state.hasConsistencyStatsError = false;
      })
      .addCase(getHabitsConsistencyStats.fulfilled, (state, { payload }) => {
        state.consistencyStats = payload ?? [];
        state.isConsistencyStatsLoading = false;
        state.hasConsistencyStatsError = false;
      })
      .addCase(getHabitsConsistencyStats.rejected, (state) => {
        state.consistencyStats = [];
        state.isConsistencyStatsLoading = false;
        state.hasConsistencyStatsError = true;
      });
  }
});

export const { resetStatsSummaries, updateSelectedHabitId } = statsSlice.actions;

export default statsSlice.reducer;
